import { actions } from 'Data/ReduxViewModels/Equipment';
import { hasValue } from 'Lib/Any';
import { useDispatch, useSelector } from 'react-redux';
import * as oPath from '../../../Lib/Object/Path/Immutable';
import { Button, ButtonGroup, Field, Message, TextOutput } from '../../Core';
import { ListFieldSection, PageSection } from '../../Layout';

const MoistureTinEquipment = () => {
  const dispatch = useDispatch();
  const associatedTestUUID = useSelector((state) => oPath.get(state.equipment.syncModel, 'data.AssociatedTestUUID'));

  return (
    <>
      <PageSection>
        <ListFieldSection>
          <Field input={<TextOutput />} label="Moisture Tin" name="Code" />
          <Field input={<TextOutput />} label="Sample ID" name="SampleId" />
          <Field input={<TextOutput />} label="Test Type" name="TestTypeName" />
          <ButtonGroup>
            <Button
              disabled={!hasValue(associatedTestUUID)}
              onClick={() => dispatch(actions.setValue({ name: 'data.AssociatedTestUUID', value: null, sync: true }))}
            >
              Remove Association
            </Button>
          </ButtonGroup>

          {!hasValue(associatedTestUUID) && (
            <Message message={'No association to test exists.'} severity="error" border={false} />
          )}
        </ListFieldSection>
      </PageSection>
    </>
  );
};

export default MoistureTinEquipment;
export { MoistureTinEquipment };
